export default __webpack_public_path__ + "static/media/nbcLogo.120e3953.svg";